import React, { useMemo } from 'react'

import { TFunction } from 'i18next'

import { PlusInCircle, SvgIcon } from '@surglogs-app/icons'
import {
  Box,
  Button,
  Icon,
  Label,
  ListItem,
  RemoveButton,
  Text,
} from '@surglogs-app/ui'

import { ComponentLoader } from '../../../ui.loader/src'

interface MfaMethodItemProps {
  label: string
  description: string
  isEnabled: boolean
  showSetup?: boolean
  setupTitle?: string
  icon?: SvgIcon
  isLoading?: boolean
  onRevoke?: () => void
  onSetup?: () => void
  t: TFunction<any>
}

export const MfaMethodItem = ({
  label,
  description,
  icon,
  isEnabled,
  showSetup = false,
  setupTitle = '',
  isLoading = false,
  onRevoke,
  onSetup,
  t,
}: MfaMethodItemProps) => {
  const statusText = useMemo(
    () => (
      <Text
        {...{
          variant: isEnabled ? 'success' : 'danger',
          bold: true,
          size: 'xxs',
        }}>
        {t(isEnabled ? 'mfaMethods.enabled' : 'mfaMethods.notSetUp')}
      </Text>
    ),
    [isEnabled, t],
  )

  return (
    <ListItem>
      {icon ? <Icon {...{ icon }} /> : null}
      <Box {...{ ml: 'md', flex: 1 }}>
        <Label {...{ bold: true }}>{label}</Label>
        <Box {...{ mb: 'xs' }}>
          <Text {...{ size: 'xxs' }}>{description}</Text>
        </Box>
        <Text {...{ bold: true, size: 'xxs' }}>
          {`${t('mfaMethods.status')}: `}
          {statusText}
        </Text>
      </Box>
      {isLoading ? <ComponentLoader {...{ w: '80px' }} /> : null}
      {isEnabled && !isLoading ? (
        <RemoveButton {...{ size: 'mini', onClick: onRevoke }}>
          {t('mfaMethods.revokeMfa')}
        </RemoveButton>
      ) : null}
      {!isEnabled && showSetup && !isLoading ? (
        <Button {...{ size: 'mini', icon: PlusInCircle, onClick: onSetup }}>
          {setupTitle}
        </Button>
      ) : null}
    </ListItem>
  )
}
